export enum ProductAvailability{
    // Summary:
        // The ag safe plus
        AGInvestPlus = 8,
        // Summary:
        // The ag fund stability
        AGFundStability = 3,
        // Summary:
        //  The ag fund neutral
        AGFundNeutral = 4,
        // Summary:
        // The ag fund dynamic
        AGFundDynamic = 4,
        // Summary:
        // The uppie moon
        UppieMoon = 8,
        // Summary:
        // The uppie star go
        UppieStarGo = 3,
        // Summary:
        // The uppie star run
        UppieStarRun = 4,
        // Summary:
        // The uppie star fly
        UppieStarFly = 4
}
